import { render, staticRenderFns } from "./DetailVanilla.vue?vue&type=template&id=6ca993c1&"
import script from "./DetailVanilla.vue?vue&type=script&lang=ts&"
export * from "./DetailVanilla.vue?vue&type=script&lang=ts&"
import style0 from "./DetailVanilla.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports